import axios from 'axios';
import { API_URL } from '../apis';
import authHeader from '../../common/AuthHeader';

const register = (businessDetails) => axios
  .post(`${API_URL}business_block/business`,
    // data: {
    //   attributes:
    {
      designation: businessDetails.designation,
      advertisement_headline: businessDetails.advertisementHeadline,
      introduction: businessDetails.introduction,
      company_name: businessDetails.companyName,
      establishment_year: businessDetails.establishmentYear,
      employee_count: businessDetails.employeeCount,
      entity_type: businessDetails.entityType,
      business_type: businessDetails.businessType,
      industry_sector: businessDetails.industrySector,
      business_website: businessDetails.businessWebsite,
      facilities: businessDetails.facilities,
      business_summary: businessDetails.businessSummary,
      annual_sales: businessDetails.annualSales,
      inventory_value: businessDetails.inventoryValue,
      gross_income: businessDetails.grossIncome,
      ebitda: businessDetails.ebitda,
      ebitda_margin: businessDetails.ebitdaMargin,
      rentals: businessDetails.rentals,
      company_head_name: businessDetails.companyHeadName,
      company_head_email: businessDetails.companyHeadEmail,
      company_head_designation: businessDetails.companyHeadDesignation,
      management_team: businessDetails.managementTeam,
      company_address: businessDetails.companyAddress,
      company_city: businessDetails.companyCity,
      company_email: businessDetails.companyEmail,
      looking_for: businessDetails.lookingFor,
      one_line_pitch: businessDetails.oneLinePitch,
      business_photo: businessDetails.businessPhoto,
      business_documents: businessDetails.businessDocuments,
      // },
    // },
    }, { headers: { token: `${authHeader().token}` } });

const Registration = [
  {
    id: 1,
    image: '',
    name: 'Business',
    quotes: 'Card Qutotation for Business.',
  },
  {
    id: 2,
    image: '',
    name: 'Investor',
    quotes: 'Card Qutotation for Investor.',
  },
  {
    id: 3,
    image: '',
    name: 'Mentor',
    quotes: 'Card Qutotation for Mentor.',
  },
  {
    id: 4,
    image: '',
    name: 'Startup',
    quotes: 'Card Qutotation for Startup.',
  },
  {
    id: 5,
    image: '',
    name: 'Lender',
    quotes: 'Card Qutotation for Lender.',
  },
  {
    id: 6,
    image: '',
    name: 'Franchise',
    quotes: 'Card Qutotation for Franchise.',
  },
];

export default {
  Registration,
  register,
};
